import React, { useEffect, useState } from 'react';
import { LanguageElement } from './components/LanguageElement';
import { useLanguage } from '../../utils/hooks/useLanguage';
import { firstLetterUpperCase, getCookieValue } from "../../utils/common";
export function I18nLanguageSwitch() {
    var t = useLanguage('i18nLanguageSwitch').t;
    var Languages = [
        { code: 'en', name: 'English' },
        { code: 'es', name: 'Español' },
        { code: 'ja', name: '日本語' },
        { code: 'tr', name: 'Türkçe' },
        { code: 'fr', name: 'Français' },
        { code: 'de', name: 'Deutsch' },
        { code: 'pt', name: 'Português' },
        { code: 'it', name: 'Italiano' },
        { code: 'nl', name: 'Nederlands' },
        { code: 'pl', name: 'Polski' }
    ];
    // Helper function to determine initial language with fallback chain
    function getInitialLanguage(supportedLanguages) {
        // Return the base code (e.g. "en-GB" -> "en") if supported, else null
        var toSupported = function (value) {
            var code = (value || '').split(/[-_]/)[0].toLowerCase();
            return supportedLanguages.some(function (lang) { return lang.code === code; }) ? code : null;
        };
        return toSupported(getCookieValue('lang')) // Check cookie first
            || toSupported(navigator.language) // Then browser language
            || 'en'; // Fallback to English
    }
    var _a = useState(getInitialLanguage(Languages)), selectedLanguage = _a[0], setSelectedLanguage = _a[1];
    var _b = useState(false), isDropdownOpen = _b[0], setIsDropdownOpen = _b[1];
    useEffect(function () {
        document.addEventListener('click', function (event) {
            var target = event.target;
            var dropdown = document.getElementById('i18n-language-switch');
            if (dropdown && !dropdown.contains(target)) {
                dropdown.classList.remove('active');
                setIsDropdownOpen(false);
            }
        });
        var element = document.getElementById('i18n-language-switch');
        if (element) {
            element.onclick = toggleLanguageDropdown;
        }
        return function () {
            if (element) {
                element.onclick = null;
            }
        };
    }, []);
    function toggleLanguageDropdown() {
        var element = document.getElementById('i18n-language-switch');
        element === null || element === void 0 ? void 0 : element.classList.toggle('active');
        setIsDropdownOpen(function (prev) { return !prev; });
    }
    var changeLanguage = function (lang) {
        toggleLanguageDropdown();
        location.href = "".concat(appContexName, "/i18n/set_locale?lang=").concat(lang, "&redirect_to=").concat(encodeURIComponent(location.href));
        // MakeGETRequest(`/i18n/set_locale`, { lang, redirect_to: location.href }).then((response) => {
        //     location.reload();
        // }).catch((error) => {
        //     console.error('Error changing language:', error);
        // });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "selectedFlag ".concat(selectedLanguage) },
            ' ',
            React.createElement("i", { className: 'flagSelected' }),
            " ",
            React.createElement("span", { className: 'flagTxt' }, firstLetterUpperCase(selectedLanguage)),
            ' '),
        React.createElement("div", { className: "flagDropDown ".concat(isDropdownOpen ? 'active' : '') },
            React.createElement("ul", null, Languages.map(function (lang) { return (React.createElement(LanguageElement, { key: lang.code, language: lang.code, isSelected: lang.code === selectedLanguage, languageName: lang.name, onClick: function () { return changeLanguage(lang.code); } })); })))));
}
